import React, { useLayoutEffect } from "react"
import createPersistedState from "use-persisted-state"

import { selectContent } from "~utils/analytics"
import Postman from "./Postman"

const loadPostman = (envTitle, credentials, anonymous) => {
  try {
    console.log("Box: Loading Postman") /* eslint-disable-line no-console */
    // console.log("Credentials:",credentials); /* eslint-disable-line no-console */
    console.log("Box: Is Anonymous:", anonymous); /* eslint-disable-line no-console */

    (function (p, o, s, t, m, a, n) {
      // eslint-disable-next-line prefer-rest-params
      !p[s] && (p[s] = function () { (p[t] || (p[t] = [])).push(arguments) })
      !o.getElementById(s + t) && o.getElementsByTagName("head")[0].appendChild((
        (n = o.createElement("script")),
        (n.id = s + t), (n.async = 1), (n.src = m), n
      ))
      if (!anonymous) {
        setupCredentials(envTitle, credentials)
      }
    }(window, document, "_pm", "PostmanRunObject", "https://run.pstmn.io/button.js"))
  } catch (error) {
    console.error("Error loading Postman:", error) /* eslint-disable-line no-console */
  }
}

// Remove all known Postman objects when the element is unloaded
const unloadPostman = () => {
  const element = document.getElementById("_pmPostmanRunObject")
  element && element.remove()

  const overlay = document.getElementById("pm-oip-overlay")
  overlay && overlay.remove()

  window && window._pm && delete window._pm
  window && window.PostmanRunObject && delete window.PostmanRunObject
}

const setupCredentials = (envTitle, credentials) => {
  console.log("Box: Setting up environment") /* eslint-disable-line no-console */
  // console.log("Credentials:",credentials); /* eslint-disable-line no-console */
  console.log("Box: Environment Title:", envTitle) /* eslint-disable-line no-console */
  window._pm("env.create", envTitle, credentials, 0)
  console.log("Box: Environment set") /* eslint-disable-line no-console */
}

const Component = ({
  id = "default",
  workspaceId = process.env.GATSBY_POSTMAN_DEFAULT_WORKSPACE_ID,
  url = `entityId=${id}&entityType=collection&workspaceId=${workspaceId}`,
  env = "credentials",
  envtitle: envTitle = "Box OAuth",
  anonymous,
}) => {
  id = id === "default" ? process.env.GATSBY_POSTMAN_DEFAULT_FORK_ID : id
  anonymous = ["", "true", true].includes(anonymous)

  const useCredentials = createPersistedState(`com.box.developer.${env}`)
  const useClientId = createPersistedState(`com.box.developer.${env}.client_id`)
  const useClientSecret = createPersistedState(
    `com.box.developer.${env}.client_secret`,
  )

  const [credentials] = useCredentials({})
  const [clientId] = useClientId("")
  const [clientSecret] = useClientSecret("")

  envTitle = `${envTitle} (${credentials.login})`

  useLayoutEffect(() => {
    loadPostman(
      envTitle,
      {
        client_id: clientId,
        client_secret: clientSecret,

        access_token: credentials.access_token,
        expires_at: credentials.expires_at,

        refresh_token: credentials.refresh_token,
        refresh_token_expires_at: (credentials.expires_at + (1000 * 60 * 60 * 24 * 50)), // 50 days from now

        enable_auto_refresh_access_token: true,

        user_id: credentials.user_id,
        enterprise_id: credentials.enterprise_id,
        box_env_type: "OAUTH",
      },
      anonymous,
    )
    return unloadPostman
  }, [])

  /**
   * Register that the user clicked this item with Google
   */
  const onClick = () => {
    const message = `Load Postman collection (${
      anonymous ? "Anonymous" : "Authenticated"
    })`
    selectContent(message)
  }

  return <Postman id={id} onClick={onClick} url={url} />
}

export default Component
